export default __webpack_public_path__ + "static/media/usecase_04.cfc45d7f.png";